import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReputationComponent } from './reputation.component';
import { ReviewUrlListComponent } from './review-url-list/review-url-list.component';
import { AddEditReviewUrlComponent } from './add-edit-review-url/add-edit-review-url.component';
import { FeedbackListComponent } from './feedback-list/feedback-list.component';
import { FeedbackDetailsComponent } from './feedback-details/feedback-details.component';
import { UserReviewListComponent } from './user-review-list/user-review-list.component';
import { UserReviewAddEditComponent } from './user-review-add-edit/user-review-add-edit.component';
import { StatisticsReviewComponent } from './statistics-review/statistics-review.component';

const routes: Routes = [
  {
    path: '',
    component: ReputationComponent,
    children: [
      {
        path: 'review-url',
        component: ReviewUrlListComponent
      },
      {
        path: 'add-review-url',
        component: AddEditReviewUrlComponent
      },
      {
        path: 'edit-review-url/:id',
        component: AddEditReviewUrlComponent
      },
      {
        path:'feedback',
        component: FeedbackListComponent
      },
      {
        path:'feedback-details/:id',
        component: FeedbackDetailsComponent
      },
      {
        path:'user-review-list',
        component: UserReviewListComponent
      },
      {
        path:'add-user-review',
        component: UserReviewAddEditComponent
      },
      {
        path:'edit-user-review/:id',
        component: UserReviewAddEditComponent
      },
      {
        path: 'statistics-review',
        component: StatisticsReviewComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReputationRoutingModule { }
